import type { Component } from 'vue';
import type { TaskItem } from '@Types/dashboard.types';
import { resolveEffectiveType } from '@Src/shared/utils/resolveEffectiveType';
import PaymentCompletionView from './PaymentCompletionView.vue';
// FraudEducationView handles BOTH active and completed states for
// fraud_education (DS-2860 unified migration).
import FraudEducationView from './FraudEducationView.vue';
import VerifyIdentityCompletionView from './VerifyIdentityCompletionView.vue';
import EsignCompletionView from './EsignCompletionView.vue';
// Kept for future use — SCC completion views are built but not routed to yet.
// Completed SCC tasks (send/collect/confirm/payment_request) re-enter the
// task flow via priming → navigation instead of showing a completion sheet.
// import WireInstructionsCompletionView from './WireInstructionsCompletionView.vue';
// import CollectCompletionView from './CollectCompletionView.vue';
// import ConfirmCompletionView from './ConfirmCompletionView.vue';

// Keyed by production TaskItem.taskType. Tasks whose type isn't in this map
// have no completion view and fall through to useTaskNavigation's default
// behavior (priming → task flow re-entry).
//
// SCC types (send, collect, confirm, payment_request, complete_scc_request)
// are intentionally excluded — completed SCC tasks re-enter the live flow
// so participants can review wire instructions / bank details in-context.
// That covers payment_request_emd and payment_request_c2c too: they are the
// same Request-backed task, split by purpose, and re-enter the same way. Only
// the PaymentTransfer-backed types below get a completion sheet, which is why
// EMITTED_PAYMENT_EFFECTIVE_TYPES lists those three and not the split pair.
// payment_other is completed-only, so it gets a sheet without a priming config.
const TASK_VIEWS: Record<string, Component> = {
    payment_emd: PaymentCompletionView,
    payment_c2c: PaymentCompletionView,
    payment_repayment: PaymentCompletionView,
    payment_other: PaymentCompletionView,
    fraud_education: FraudEducationView,
    match: VerifyIdentityCompletionView,
    complete_match_request: VerifyIdentityCompletionView,
    document_signing: EsignCompletionView,
};

export function resolveTaskView(task: TaskItem): Component | null {
    const effective = resolveEffectiveType(task);
    if (!effective) return null;
    return TASK_VIEWS[effective] ?? null;
}

export function hasTaskView(task: TaskItem): boolean {
    return resolveTaskView(task) !== null;
}
